"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEditorStyles = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var useEditorStyles = exports.useEditorStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      "& h1": {
        fontFamily: theme.typography.h5.fontFamily,
        fontSize: theme.typography.h5.fontSize,
        fontWeight: theme.typography.h5.fontWeight,
        lineHeight: theme.typography.h5.lineHeight,
        margin: 0,
        marginBottom: theme.spacing(1)
      },
      "& h2": {
        fontFamily: theme.typography.h6.fontFamily,
        fontSize: theme.typography.h6.fontSize,
        fontWeight: theme.typography.h6.fontWeight,
        lineHeight: theme.typography.h6.lineHeight,
        margin: 0,
        marginBottom: theme.spacing(1)
      },
      "& h3": {
        fontFamily: theme.typography.subtitle1.fontFamily,
        fontSize: theme.typography.subtitle1.fontSize,
        fontWeight: theme.typography.subtitle1.fontWeight,
        lineHeight: theme.typography.subtitle1.lineHeight,
        margin: 0,
        marginBottom: theme.spacing(1)
      },
      "& p": {
        fontFamily: theme.typography.body2.fontFamily,
        fontSize: theme.typography.body2.fontSize,
        fontWeight: theme.typography.body2.fontWeight,
        lineHeight: theme.typography.body2.lineHeight,
        margin: 0,
        marginBottom: theme.spacing(1)
      },
      "& h1, h2, h3, h4, h5, p": {
        "&:empty": {
          "&:after": {
            content: "'.'",
            visibility: "hidden"
          }
        }
      },
      "& ul": {
        paddingLeft: 15
      }
    }
  };
});
function EditorDisplay(_ref) {
  var content = _ref.content;
  var _useEditorStyles = useEditorStyles(),
    root = _useEditorStyles.root;
  var removeQueryStringFromImages = function removeQueryStringFromImages(content) {
    var imgRegex = /(<img[^>]+)src="([^"]+)\?[^"]+"([^>]*>)/g;
    var sanitizedContent = (content || "").replace(imgRegex, '$1src="$2"$3');
    return sanitizedContent;
  };
  var sanitizedContent = removeQueryStringFromImages(content);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: root,
    dangerouslySetInnerHTML: {
      __html: sanitizedContent
    }
  });
}
var _default = exports["default"] = EditorDisplay;